import { useState } from 'react';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

export const ChatContext = ({show, setShow, chatContext, setChatContext, conversationid}) => {
    const [ ephemeralChatContext, setEphemeralChatContext ] = useState(chatContext);
    const [ curConversationid, setCurConversationid ] = useState(conversationid);

    if (curConversationid !== conversationid) {
        if (chatContext !== '') {
            setChatContext('');
        }

        if (ephemeralChatContext !== '') {
            setEphemeralChatContext('');
        }
        
        setCurConversationid(conversationid);
    }
    
    const handleChatContextChange = (changeEvent) => {
        const newChatContext = changeEvent.target.value;
        setEphemeralChatContext(newChatContext);
    }

    const handleChatContextClose = (doUpdateContext) => {
        if (doUpdateContext) {
            if (ephemeralChatContext !== chatContext) {
                setChatContext(ephemeralChatContext);
            }
        } else {
            if (ephemeralChatContext !== chatContext) {
                setEphemeralChatContext(chatContext);
            }
        }

        if (show) {
            setShow(false);
        }
    }

    return <Modal show={show} size="xl" onHide={() => handleChatContextClose(false)}>
        <Modal.Header 
            closeButton
            className="text-muted py-2"
            style={{backgroundColor:'rgba(33, 37, 41, 0.03)'}}
        >
            <Modal.Title>
                <i className="bi-puzzle mx-2" />
                Additional Context
                <div style={{
                    fontSize: ".65em",
                    fontStyle: "italic",
                    fontWeight: "normal",
                    paddingLeft: "2.5rem"
                }}>
                    Enter additional context for the chatbot to augment its existing knowledge
                </div>
            </Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4">
            <Form.Control
                id="queryContextTextArea"
                as="textarea"
                rows={20}
                placeholder=""
                value={ephemeralChatContext}
                onChange={(changeEvent) => handleChatContextChange(changeEvent)}
                autoFocus
            />
        </Modal.Body>
        
        <Modal.Footer style={{backgroundColor:'rgba(33, 37, 41, 0.03)'}}>
                <div style={{
                    float: "left",
                    fontStyle: "italic",
                    position: "absolute",
                    left: "1rem"
                }}>
                    The chatbot will prioritize this context over its general knowledge.<br />You can add additional context later, but this context will remain for the entirety of the conversation.
                </div>
            <Button variant="secondary" onClick={() => handleChatContextClose(false)}>
                Cancel
            </Button>
            <Button variant="primary" onClick={() => handleChatContextClose(true)}>
                Save Context
            </Button>
        </Modal.Footer>
    </Modal>
}